import { QueryClient } from '@tanstack/react-query'

// The hand-rolled loaders behind `useEvents`, `useEvent` and
// `useRegistrationForm` fetched on mount and threw the answer away the moment
// the component unmounted, so walking away from a screen and straight back cost
// a full round trip every time.
//
// The defaults below are chosen to change as little else as possible. The old
// loaders did not retry, did not refetch on focus, and did not refetch on
// reconnect, so neither does this. `staleTime` is the only deliberate
// difference: an answer is good for thirty seconds, which is what makes
// navigating back free without pinning a screen to stale data for the session.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 0,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
})
